import React from "react";
import { connect } from "react-redux";
import {getHedgeFiles, addFileToHedge, deleteHedgeFile} from 'store/state/hedge';
import AttachmentsDrawer from 'components/Global/Attachments/AttachmentsDrawer';
import _ from 'lodash';

class HedgeAttachments extends React.Component {

  componentDidUpdate(prevProps, prevState){
    const { hedgeId,isOpen} = this.props;
    const {isOpen: prevIsOpen} = prevProps;
    if(isOpen !== prevIsOpen && isOpen){
      this.props.getHedgeFiles({
        modelName: 'hedge',
        modelId:hedgeId,
        subKey: hedgeId
      })
    }
  }

  handleRemoveFile = (fileId) => {
    const {hedgeId} = this.props;
    this.props.deleteHedgeFile({
      fileId: fileId, 
      shouldUpdateAfter:true, 
      modelName: 'hedge',
      modelId: hedgeId,
      subKey:hedgeId });
  }

  render() {
    const {isOpen, closeAttachments, hedgeFiles, hedgeId,addFileToHedge, isLoading} = this.props;    
    const specificHedgeFiles = hedgeFiles[hedgeId] || [];

    return (
      <React.Fragment>
        <AttachmentsDrawer
          internalID = {"ForHedge"+hedgeId}
          drawerWidth={600}
          addFile={(file) => addFileToHedge('hedge', hedgeId, file)}
          isOpen={isOpen}
          isLoading={isLoading}
          closeDrawer={closeAttachments}
          files={specificHedgeFiles} 
          handleRemove={this.handleRemoveFile}/>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ hedge, loading}) => ({
  hedgeFiles: hedge.hedgeFiles,
  isLoading: loading.hedge_file_upload
});

export default connect(
  mapStateToProps,
  {   
    getHedgeFiles,
    addFileToHedge,
    deleteHedgeFile
  }
)(HedgeAttachments);

